export default __webpack_public_path__ + "static/media/4icon.ba059ed3.svg";